import { render } from "./ShowSellos.vue?vue&type=template&id=cc683554&scoped=true"
import script from "./ShowSellos.vue?vue&type=script&lang=js"
export * from "./ShowSellos.vue?vue&type=script&lang=js"

import "./ShowSellos.vue?vue&type=style&index=0&id=cc683554&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cc683554"

export default script